export const nations: { [key: string]: string } = {
  GER: 'de',
  AUT: 'at',
  SUI: 'ch',
  ESP: 'es',
  BUL: 'bg',
  USA: 'us',
  FRA: 'fr',
  BEL: 'be',
  CRO: 'hr',
  ARG: 'ar',
  SRB: 'rs',
  RSA: 'za',
  GBR: 'gb',
  CZE: 'cz',
};



// WEBPACK FOOTER //
// ./src/app/constants/nations.ts